import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_BULK_VARIANTS, GET_VARIANT_DEFINITION, GET_VARIANT_OVERRIDES } from 'ContentData/api/Variants';
export const useFetchBulkVariants = () => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_BULK_VARIANTS);
  return useMemo(() => {
    return {
      data: data === null || data === void 0 ? void 0 : data.bulkVariants,
      loading,
      error
    };
  }, [data, loading, error]);
};
export const useFetchVariantDefinition = variantDefinitionName => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_VARIANT_DEFINITION, {
    variables: {
      variantDefinitionName
    },
    skip: !variantDefinitionName
  });
  return useMemo(() => {
    return {
      data: data === null || data === void 0 ? void 0 : data.variantDefinition,
      loading,
      error
    };
  }, [data, loading, error]);
};
export const useFetchVariantOverrides = variantDefinitionName => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_VARIANT_OVERRIDES, {
    variables: {
      variantDefinitionName
    },
    skip: !variantDefinitionName
  });
  return useMemo(() => {
    return {
      data: data === null || data === void 0 ? void 0 : data.variantOverrides,
      loading,
      error
    };
  }, [data, loading, error]);
};